/**
 * Test whether a value is an object--that is, a non-null, non-array value of type 'object'
 *
 * @param {*} object - The value to be evaluated
 * @returns {boolean} True if the value is truthy, an object, and not an array; false otherwise.
 */
export const isObject = (object) =>
  !!(object && typeof object === 'object' && !Array.isArray(object));
